import { Injectable } from '@angular/core';

import {
  MOBILE_BREAKPOINT_WIDTH,
  MOBILE_BREAKPOINT_HEIGHT,
} from '@app/app.tokens';

@Injectable()
export class MediaMatcherService {
  private mediaMatcher: MediaQueryList = matchMedia(
    `(max-width: ${MOBILE_BREAKPOINT_WIDTH}px), (max-height: ${MOBILE_BREAKPOINT_HEIGHT}px)`
  );

  public isMobile(): boolean {
    return this.mediaMatcher.matches;
  }
}
